module.exports = __webpack_public_path__ + "static/audience-corporates-4c2bb08b58ae04755a61ce1e44f3e133.jpg";